import { render, staticRenderFns } from "./ClientsAndStoresCharts.vue?vue&type=template&id=6178afe8&"
import script from "./ClientsAndStoresCharts.vue?vue&type=script&lang=js&"
export * from "./ClientsAndStoresCharts.vue?vue&type=script&lang=js&"
import style0 from "./ClientsAndStoresCharts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports